export default __webpack_public_path__ + "static/dreamreality-trans-3e2d16f41f1756813e05193624e03c21.png";